import { connect } from 'react-redux'
import * as action from '../../state/list/action'
import * as selector from '../../state/list/selector'
import ShipmentList from './ShipmentList'

const mapStateToProps = (state, props) => {
    return {
        ...selector.selectOwnState(state),
    }
}

const mapDispatchToProps = {
    createShipment: action.createShipment,
    toggleShipmentTracking: action.toggleShipmentTracking,
}


export default connect(mapStateToProps, mapDispatchToProps)(ShipmentList)



// WEBPACK FOOTER //
// ./src/modules/logistic/component/list/ShipmentListContainer.js